import { render, staticRenderFns } from "./noticeScrollX.vue?vue&type=template&id=3cae06d2&scoped=true"
import script from "./noticeScrollX.vue?vue&type=script&lang=js"
export * from "./noticeScrollX.vue?vue&type=script&lang=js"
import style0 from "./noticeScrollX.vue?vue&type=style&index=0&id=3cae06d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cae06d2",
  null
  
)

export default component.exports